import { Paper, Collapse, Backdrop, Typography } from '@mui/material';
import { FC } from 'react';

import { 
  JobSearchKeywordInput, 
  JobSearchLocationInput, 
  JobSearchRadiusInput, 
  JobSearchStartDateInput,
  JobSearchCompensationInput,
  JobSearchBenefitsInput,
  JobSearchCommitmentInput,
  JobSearchCommissionInput
} from '@carcareers/components';

interface JobSearchFilterModalProps {
  open: boolean;
  onClose: () => void;
}

export const JobSearchFilterModal: FC<JobSearchFilterModalProps> = ({ open, onClose }) => {
  const handlePaperClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
  };

  return (
    <Backdrop
      open={open}
      sx={{ zIndex: 1, top: { xs: '56px', sm: '64px' }, justifyContent: 'center', alignItems: 'start' }}
      onClick={onClose}
    >
      <Collapse
        in={open}
        timeout={150}
        sx={{
          zIndex: 2,
          width: '100%',
          maxWidth: '1240px',
          justifyContent: 'center',
          alignItems: 'start',
        }}
      >
        <Paper
          elevation={0}
          onClick={handlePaperClick}
          sx={{
            borderTopRightRadius: 0,
            borderTopLeftRadius: 0,
            borderBottomRightRadius: 15,
            borderBottomLeftRadius: 15,
            bgcolor: 'background.paper',
            color: 'text.primary',
            p: 2,
            maxHeight: { xs: 'calc(100vh - 72px)', sm: 'calc(100vh - 96px)' },
            overflowX: 'hidden',
            overflowY: 'auto',
          }}
        >
          <Typography variant="h6" sx={{ mb: 2 }}>Filters</Typography>
          <JobSearchKeywordInput sx={{ display: { xs: 'flex', sm: 'none' } }} />
          <JobSearchLocationInput sx={{ display: { sm: 'flex', md: 'none' }, width: '100%' }} />
          <JobSearchRadiusInput />
          <JobSearchStartDateInput sx={{ mt: 3 }} />
          <JobSearchCompensationInput sx={{ mt: 3 }} />
          <JobSearchCommissionInput sx={{ mt: 3 }} />
          <JobSearchCommitmentInput sx={{ mt: 3 }} />
          <JobSearchBenefitsInput sx={{ mt: 3 }} />
        </Paper>
      </Collapse>
    </Backdrop>
  );
};

export default JobSearchFilterModal;
